import { config, setBasicAuth } from '../configuration';
import { addToast } from '~features/toast/ducks';
import * as api from '~services/api.cordova';

/** *****************************************
 * Notifications (Firebase Cloud Messaging)
 * ****************************************** */

// Old implementation using 'cordova-plugin-fcm'

// export function attachNotificationHandlers(store) {
//   console.log('Setting notification handler...');

//   // Register token to server
//   window.FCMPlugin.getToken(token => {
//     console.log('My FCM token is', token);
//     api
//       .post('users/me/pushToken/', token)
//       .then(() => console.log('FCM token registered to server'))
//       .catch(() => console.log('Failed to register FCM token to server'));
//   });

//   window.FCMPlugin.onNotification(data => {
//     console.log('------> Notification received!', data);
//     if (data.wasTapped) {
//       // Notification was received on device tray and tapped by the user.
//       alert(JSON.stringify(data)); // eslint-disable-line
//     } else {
//       // Notification was received in foreground.
//       // Maybe the user needs to be notified.
//       store.dispatch(
//         addToast({
//           message: 'Ilmoitus saapui!',
//         })
//       );
//     }
//   });
// }

// New implementation using plugin 'cordova-plugin-push':

export function appToBackground() {
  console.log('App went to background');
}

export function appToForeground() {
  // TODO Call ping on the server to check authentication session. How to access store???
  console.log('App came to foreground');
}

let authSuccess = false;

const registerToken = token => {
  console.log('Registering FCM token...', token);
  document.myFmcToken = token;

  if (token && authSuccess) {
    const headers = {
      'Content-Type': 'application/json',
    };
    api
      .post('/users/me/fcmToken', { token }, null, headers)
      .then(() =>
        console.log('[push notifications] FCM token registered to server')
      )
      .catch(() =>
        console.log(
          '[push notifications] Failed to register FCM token to server'
        )
      );
  } else {
    console.log(
      `[push notifications] Token not sent, authenticated: ${authSuccess}, key: ${token}`
    );
  }
};

export function attachNotificationHandlers(store) {
  console.log('[push notifications] Setting notification handlers');

  // eslint-disable-next-line no-undef
  PushNotification.createChannel(
    () => {
      console.log('success');
    },
    () => {
      console.log('error');
    },
    {
      id: 'PushPluginChannel',
      description: 'Tilaajailmoitukset',
      importance: 5,
      vibration: true,
    }
  );

  // eslint-disable-next-line no-undef
  const push = PushNotification.init({
    android: {
      alert: 'true',
      badge: 'true',
      sound: 'true',
    },
    browser: {},
    ios: {
      alert: 'true',
      badge: 'true',
      sound: 'true',
    },
    windows: {},
  });

  push.on('registration', data => {
    // alert(JSON.stringify(data));
    console.log('[push notifications] registration-handler, event:');
    console.log(JSON.stringify(data));
    registerToken(data.registrationId);
    console.log(`[push notifications] Token: ${data.registrationId}`);
  });

  push.on('notification', data => {
    // alert(JSON.stringify(data));
    console.log('[push notifications] notification-handler, event:');
    console.log(JSON.stringify(data));

    const isForeground = data.additionalData.foreground;
    const badgeNumberDefined = data.count || data.count === '0';
    const badgeNumber = data.count;
    const toastMessage = data.title;

    if (isForeground) {
      if (toastMessage) {
        navigator.notification.beep(1);
        store.dispatch(
          addToast({
            message: toastMessage,
          })
        );
      }
      if (badgeNumberDefined) {
        console.log(`Setting badge number to: ${badgeNumber}`);
        push.setApplicationIconBadgeNumber(
          () => {
            console.log('Badge change success');
          },
          () => {
            console.log('Badge change error');
          },
          badgeNumber
        );
      }
    } else {
      console.log('Notification received at background.');
    }
  });

  console.log('[push notifications] Notification handlers set.');
}

/** **************
 * Authentication
 * *************** */

let browserRef;

function handleLoginBrowserLoadStop(event) {
  const { url } = event;
  console.log(`[authenticate] loadstop-handler of inappbrowser: ${url}`);
  if (event) console.log(JSON.stringify(event));

  // Check if the auth process has come to an end (reached certain url)
  // If we have => close the browser and render the app.

  // New style of checking successful authentication or existing session.
  if (
    (config.authenticatedUrl && url === config.authenticatedUrl) ||
    url === config.host ||
    (url.startsWith(config.host) && !url.includes('/Login/')) // TODO Includes the previous one?
  ) {
    console.log(`[authenticate] Authentication was successful: ${url}`);
    authSuccess = true;
    browserRef.close();
  }

  // Old style.
  else if (
    !config.authenticatedUrl &&
    url !== config.authUrl &&
    url.indexOf('authenticated.html') !== -1
  ) {
    console.log(`[authenticate] Authentication was successful:${url}`);
    browserRef.close();
  }
}

function onImprivataEvent(event) {
  console.log('Imprivata event:');
  console.log(event);

  if(event.info === 'userLogout') {
    console.log('User logged out.');
    window.cordovaImprivata.logout();
  }
}

/**
 *
 */
export function authenticate() {
  if (config.isImprivata) {

    if(__TEST_USER__) {
      return new Promise((resolve, reject) => {
        const user = __TEST_USER__;
        const auth = "Basic " + btoa(__TEST_USER__ + ":" + __TEST_USER__);
        console.log(`[authentication] Fake test client authentication using username: ${user}, authorization: ${auth}`);
        setBasicAuth(user, auth);
        authSuccess = true;
        resolve();
      });
    }
    
    //
    // Imprivata authentication.
    //

    console.log(
      `[authentication] Starting authentication using Imprivata:${config.authUrl}`
    );
    authSuccess = false;

    return new Promise((resolve, reject) => {

      window.cordovaImprivata
        // .userInfo(information =>
        //   setBasicAuth(information.username, information.basicAuth)
        // )
        .userInfo((information) => {
          console.log(`[authentication] Starting authentication using username: ${information.username}, authorization: ${information.basicAuth}`);
          if(information.username === 'Guest') {
              alert("Paketin käyttö vierastilassa ei ole mahdollista.");
              window.cordovaImprivata.logout();
          }
          setBasicAuth(information.username, information.basicAuth);
        })

        .then(window.cordovaImprivata.listen(onImprivataEvent)) // Should be before the authentication to avoid timing issues.
        .then(() => resolve())
        .catch(e => reject(e));
    });
  }

  //
  // mPollux SSO authentication with browser windows.
  //

  // function authenticatePollux() {
  console.log(
    `[authentication] Starting authentication using inappbrowser:${config.authUrl} ==> ${config.authenticatedUrl}`
  );
  authSuccess = false;

  return new Promise((resolve, reject) => {
    // // To test what happens if I just try to communicate with the server without authenticating.
    // resolve();

    console.log('[authenticate] Opening InAppBrowser');

    if (browserRef) {
      console.log('[authenticate] inappbrowser is already defined. abort.');
      return;
    }

    browserRef = window.cordova.InAppBrowser.open(
      config.authUrl,
      // '_system',
      '_blank',
      'location=no,toolbar=no,hideurlbar=yes,hidenavigationbuttons=yes'
    );

    browserRef.addEventListener('loadstop', handleLoginBrowserLoadStop);

    browserRef.addEventListener('loaderror', err => {
      console.log(
        '[authenticate] loaderror-handler inappbrowser [authenticate]:'
      );
      if (err?.message) console.log(err.message);
      browserRef.close();
      reject(err);
    });

    browserRef.addEventListener('exit', () => {
      console.log('[authenticate] exit-handler inappbrowser.');
      browserRef = undefined;
      resolve();
    });
  });
  // }
}

//
// Logout
//

function destroyCoockiesAndExit() {
  if (browserRef) browserRef.close();
  browserRef = undefined;
  console.log('Deleting cookies');
  api
    .del('cookies')
    .then(() => {
      console.log('Cookies deleted. Exit.');
      navigator.app.exitApp();
    })
    .catch(() => {
      console.log('Failed to delete cookies. Exit.');
      navigator.app.exitApp();
    });
}

function handleLogoutBrowserLoadStop({ url }) {
  if (url.indexOf(config.loggedOutUrl) !== -1) {
    destroyCoockiesAndExit();
  }
}

export function logout(discardCookiesUrl) {
  if (config.isImprivata) {
    //
    // Imprivata logout: Call logout at server to end session and clear cookies and exit regardless of the result.
    //

    console.log('Logging out.');
    api
      .del('cookies') // TODO Should be performed directly from the SDK.
      .then(() => {
        console.log('Cookies deleted. Exit.');
        window.cordovaImprivata.logout();
      })
      .catch(() => {
        console.log('Failed to delete cookies. Exit.');
        window.cordovaImprivata.logout();
      });
  } else {
    //
    // mPollux SSO authentication with browser windows.
    //

    console.log('> Opening InAppBrowser [logout]');

    if (browserRef) {
      console.log('> InAppBrowser is already defined - returning...');
      return;
    }

    // Open inappbrowser in logout url to discard cookies
    browserRef = window.cordova.InAppBrowser.open(
      discardCookiesUrl,
      '_blank',
      'location=no,toolbar=no,hideurlbar=yes,hidenavigationbuttons=yes'
    );

    browserRef.addEventListener('loadstop', handleLogoutBrowserLoadStop);
    browserRef.addEventListener('loaderror', err => {
      console.log('[authenticate]  Error InAppBrowser [logout]', err);
      browserRef.close();
      browserRef = undefined; // cleanup
    });

    // Destroy anyway, as logout might sometimes fail, leaving useless cookies behind and login window open.
    setTimeout(() => {
      destroyCoockiesAndExit();
    }, 5000);
  }
}

export function openPage(url) {
  console.log('Opening page:', url);
  browserRef = window.cordova.InAppBrowser.open(
    url,
    '_blank',
    'location=no,hardwareback=no'
  );

  browserRef.addEventListener('loaderror', () => {
    browserRef.close();
  });

  browserRef.addEventListener('exit', () => {
    browserRef = undefined;
  });
}
